import { createFileRoute } from "@tanstack/react-router";
import { PublicHealthProfilePage } from "@/features/public-health-profile/pages/public-health-profile-page";

export const Route = createFileRoute("/profile/$healthProfileId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { healthProfileId } = Route.useParams();
  return <PublicHealthProfilePage healthProfileId={healthProfileId} />;
}
